import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { environment } from '../../environments/environment';
import { ApiService } from '../services/api.service';

@Component({
  selector: 'ngx-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss']
})
export class ContactComponent implements OnInit {
  public siteKey : any;
  public contactForm: FormGroup;
  private Name : String;
  private Email: String;
  private Subject: String;
  private Message: String;
  constructor(    
    private fb: FormBuilder,
    private _apiService: ApiService,

    ) {
   }

  ngOnInit(): void {
    this.siteKey = environment.GOOGLE_RECAPTCHA_SITE_KEY;
    this.contactForm = this.fb.group({
      name: [],
      email: [],
      subject: [],
      message: [],
      recaptcha: ["", Validators.required],
    })
  }

 async sendContactForm() {
  let data = {};
  this.Name = this.contactForm.get('name')?.value;
  this.Email = this.contactForm.get('email')?.value;
  this.Subject = this.contactForm.get('subject')?.value;
  this.Message = this.contactForm.get('message')?.value;

  data['Name'] = this.Name;
  data['Email'] = this.Email;
  data['Subject'] = this.Subject;
  data['Message'] = this.Message;

  this._apiService.insertContactMessage(data).subscribe();
  }
  

}
